import React, { useRef } from 'react';
import Styled from 'styled';

import defaultStyles from './field-with-label.scss';

interface Props {
    styles: typeof defaultStyles;
    id?: string;
    field: React.DetailedReactHTMLElement<any, HTMLElement>;
    label: React.ReactNode;
}

const FieldWithLabel: React.FC<Props> = props => {
    const id = useRef(`label-${Math.random()}`);

    const { field, label, styles } = props;

    return (
        <div className={styles.fieldWithLabel}>
            <div className={styles.label}>
                <label htmlFor={props.id || id.current}>{label}</label>
            </div>
            <div className={styles.field}>{React.cloneElement(field, { id: props.id || id.current })}</div>
        </div>
    );
};

export default Styled(defaultStyles)(FieldWithLabel);
